<script setup lang="ts">
  import { type HTMLAttributes } from 'vue'
  import { Primitive, type PrimitiveProps } from 'reka-ui'
  import { cn } from '@rapoo/element'

  interface Props extends PrimitiveProps {
    class?: HTMLAttributes['class']
  }

  const props = withDefaults(defineProps<Props>(), {
    as: 'div',
  })
</script>

<template>
  <Primitive :as="as" :as-child="asChild" :class="cn('block max-w-308 mx-auto', props.class)">
    <slot />
  </Primitive>
</template>
